import { render } from "./CareerDetails.vue?vue&type=template&id=79cc56b3"
import script from "./CareerDetails.vue?vue&type=script&lang=js"
export * from "./CareerDetails.vue?vue&type=script&lang=js"

import "./CareerDetails.vue?vue&type=style&index=0&id=79cc56b3&lang=css"

import exportComponent from "/var/www/digiasia.asia.bak/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__